module.exports = __webpack_public_path__ + "static/img/工序类别.e97773e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/工序类别.png
// module id = gUhW
// module chunks = 2